/* KIKIELF Storefront — global.js */
(function () {
  'use strict';

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2);
    format = format || window.KK_MONEY_FORMAT || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  };

  function toast(msg) {
    var el = document.getElementById('kk-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'kk-toast';
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main] img');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      var activate = function () {
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (main) {
          main.src = btn.dataset.src;
          if (btn.dataset.srcset) main.srcset = btn.dataset.srcset; else main.removeAttribute('srcset');
          main.alt = btn.querySelector('img') ? btn.querySelector('img').alt : '';
        }
      };
      btn.addEventListener('click', activate);
      btn.addEventListener('mouseenter', activate);
    });
  }

  /* ---------- Product form: variants, price, add to cart ---------- */
  function initProductForm(section) {
    var dataEl = section.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = section.querySelector('form[data-product-form]');
    var idInput = section.querySelector('input[name="id"]');

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function renderPrice(variant) {
      var priceEls = section.querySelectorAll('[data-price]');
      var listEls = section.querySelectorAll('[data-list-price]');
      var badgeEls = section.querySelectorAll('[data-deal-badge]');
      var saveEls = section.querySelectorAll('[data-save-amount]');
      var hasDeal = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEls.forEach(function (el) { el.textContent = money(variant.price); });
      listEls.forEach(function (el) {
        el.style.display = hasDeal ? '' : 'none';
        var s = el.querySelector('s');
        if (s) s.textContent = money(variant.compare_at_price);
      });
      badgeEls.forEach(function (el) {
        if (hasDeal) {
          el.style.display = '';
          el.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
        } else {
          el.style.display = 'none';
        }
      });
      saveEls.forEach(function (el) {
        el.style.display = hasDeal ? '' : 'none';
        el.textContent = money(variant.compare_at_price - variant.price);
      });
    }

    function renderAvailability(variant) {
      var stockEl = section.querySelector('[data-stock]');
      var atcBtns = section.querySelectorAll('[data-atc]');
      var available = variant && variant.available;
      if (stockEl) {
        stockEl.textContent = available ? stockEl.dataset.inText : stockEl.dataset.outText;
        stockEl.classList.toggle('is-out', !available);
      }
      atcBtns.forEach(function (b) {
        b.disabled = !available;
        b.textContent = available ? b.dataset.atcText : b.dataset.soldText;
      });
    }

    function onVariantChange() {
      var variant = findVariant(selectedOptions());
      if (!variant) { renderAvailability(null); return; }
      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      renderAvailability(variant);
      if (variant.featured_image) {
        var main = section.querySelector('[data-gallery-main] img');
        if (main) { main.src = variant.featured_image.src; main.removeAttribute('srcset'); }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    section.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name === 'checkout') return;
        e.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
            return r.json();
          })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            toast('Added to cart ✓');
          })
          .catch(function (err) { toast(err.message); });
      });
    }
  }

  /* ---------- Cart page: qty change auto-submit ---------- */
  function initCartPage() {
    document.querySelectorAll('[data-cart-line-qty]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var line = sel.dataset.line;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(sel.value, 10) })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    });
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(btn.dataset.cartRemove, 10), quantity: 0 })
        }).then(function () { window.location.reload(); });
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-section]').forEach(initProductForm);
    initCartPage();
    initReveal();
  });
})();
